// Exports
export default {
	"switch": "switch_x20yh",
	"switchSpace": "switchSpace_kLqVx",
	"switchDescription": "switchDescription_RWz5P"
};
